import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowShareRight"><Path d="M11.6055 7.75876V2.10547L22.9993 12.0001L11.6055 21.8948V16.255C7.857 16.3049 5.83111 16.7361 4.58768 17.4096C3.31656 18.0981 2.77927 19.0796 2.02629 20.5855L0.605469 20.2501C0.605469 15.972 1.22365 12.7824 3.1105 10.6859C4.9046 8.69244 7.69092 7.85113 11.6055 7.75876Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowShareRight;
